import { render, staticRenderFns } from "./TurnsModal.vue?vue&type=template&id=75c26620&scoped=true&lang=pug"
import script from "./TurnsModal.vue?vue&type=script&lang=js"
export * from "./TurnsModal.vue?vue&type=script&lang=js"
import style0 from "./TurnsModal.vue?vue&type=style&index=0&id=75c26620&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c26620",
  null
  
)

export default component.exports